import React from "react";
import ContactDetails from "../../../_components/Contacts/ContactDetails";
import {
    getCustomerById, updateCustomer, createCustomer,
    getCustomerCompanyNames,
} from "../../../_services/contact.service";

export default function CustomerDetails() {
    return (
        <ContactDetails
            type="Customer"
            fetchById={getCustomerById}
            updateItem={updateCustomer}
            createItem={createCustomer}
            fetchCompanyNames={getCustomerCompanyNames}
        />
    );
}